import './Footer.css';
import mrlogo from './images/M_R-White.png';


function Footer() {
  return (
    <div class="footer">
        <img src={mrlogo} width="100px" alt="marco_rennmaus logo"></img>
    </div>
  );
}

export default Footer;
